import { typedQueryClient, useTypedMutation } from "hooks";
import { STATUS_IDENTIFIERS } from "models";
import { AppointmentDetailsKeys } from "modules/AppointmentDetails/queryKeys";
import { ApiInstance } from "utils/Api";

type CancelReasonPayload = {
  appointment_id: number;
  custom_reason?: string;
  reason_id?: number;
};

export const useCancelAppointmentMutation = () =>
  useTypedMutation<CancelReasonPayload, void>({
    mutationFn: async payload => {
      await ApiInstance.post("/status/set_cancel", payload);
    },
    onSuccess: () => {
      const appointment = typedQueryClient.getQueryData(AppointmentDetailsKeys.view);
      if (!appointment) return;

      typedQueryClient.setQueryData(AppointmentDetailsKeys.view, { ...appointment, appointment_status_identifier: STATUS_IDENTIFIERS.CanceledStatus });
    }
  });
